// スクラッチしたテーブル
import commonClass from "./commonClass";

export default class scratchTableClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._THead = '.js-thead';
    this._TBody = '.js-tbody';
    this._clm_check = '.js-clm_check';
    this._row_check = '.js-row_check';
    this._row_check_dl = '.js-row_check-del';
    this._sortTable = '.js-sort_table';
    this._nonSortTable = '.js-nonsort_table'
    this._resizeColumnTable = '.js-resize_clm_table';
    this._dragdropTable = '.js-drag_drop_table';
    this._checkAll = '.js-check_all';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    if(!$('.js-dlvry').length) {
      this._eClmCheck();
      this._eRowCheck();
      this._eCheckAll();
      this._initNonSortTable();
    }
    //this._deliverySchedule('.js-dlvry');

    // テーブル並び替え
    // 各HTML内で個別指定する
    // $(this._sortTable).DataTable({
    //   // 件数切替機能 無効
    //   lengthChange: false,
    //   // 検索機能 無効
    //   searching: false,
    //   // ソート機能 有効
    //   ordering: true,
    //   // 情報表示 無効
    //   info: false,
    //   // ページング機能 無効
    //   paging: false,
    //   // 横スクロールバー 有効
    //   scrollX: true,
    //   default orderを無効
    //   order: [],
    //   // ソートの可否を個別設定
    //   columns: [
    //     null,
    //     { orderable: false },
    //     null,
    //     { orderable: false },
    //     null,
    //     { orderable: false },
    //     { orderable: false },
    //     null,
    //     null,
    //     null,
    //     null,
    //     null,
    //     null,
    //     null,
    //     { orderable: false },
    //     { orderable: false },
    //     null,
    //   ],
    // });
    // テーブル ドラッグ&ドロップ操作
    this._initDragdropTable();

    // カラム幅ドラッグ変更開始
    this._resizeColumnWidth();
  }

  // テーブル ドラッグ&ドロップ操作
  _initDragdropTable () {
    function fixPlaceHolderWidth(event, ui){
      // adjust placeholder td width to original td width
      ui.children().each(function(){
        $(this).width($(this).width());
      });
      return ui;
    };

    $(this._dragdropTable).each(function(index, el) {
      $(el).sortable({
        placeholder: 'ui-state-highlight',
        start: function(event, ui){
          ui.placeholder.height(ui.helper.outerHeight());
        },
        helper: fixPlaceHolderWidth
      });
    });
  }

  // カラム幅ドラッグ変更
  _resizeColumnWidth () {
    var scrollAreaSelector = '.dataTables_scroll';
    var headSelector = '.dataTables_scrollHead';
    var bodySelector = '.dataTables_scrollBody';
    var resizeColumnSellector = '.js-resize_clm';
    var windowResizeTime = new Date().getTime();

    $(window).on('resize', function() {
      windowResizeTime = new Date().getTime();
    });

    // DOMのスタイル変更監視
    var domStyleWatcher = {
      Start: function(tgt, styleobj){
        //発生
        function eventHappen(data1, data2){
          var throwval = tgt.css(styleobj);
          tgt.trigger('domStyleChange', [throwval]);//eventを投げる
        }
        //監視の登録
        var tge = tgt[0];//jQueryオブジェクトをelementに変えてる
        var filter = ['style'];//styleを見る
        var options = {//監視オプション
          attributes: true,
          attributeFilter: filter
        };
        var mutOb = new MutationObserver(eventHappen);//監視用インスタンス作成
        mutOb.observe(tge, options);//監視開始
        return mutOb;//一応return
      },
      Stop: function(mo){
        mo.disconnect();
      }
    };

    // 変更発火時実行処理
    function catchEvent(event, value){
      var $self = $(event.currentTarget);
      var $tgtHead = $self.closest(headSelector);
      var $tgtBody = $tgtHead.siblings(bodySelector);
      var $th = $self.closest('tr').find('th');
      // 最後にwindowにリサイズイベントが走った時間との時間差を取得（ms）
      var windowResizeTimeDiff = new Date().getTime() - windowResizeTime;

      // window幅変更時のサイズ変更は実行しない
      // 500ms以内の場合はwindow幅変更によるものとする
      if (windowResizeTimeDiff > 500) {
        $tgtBody.find('tr').each(function(index, el) {
          var $td = $(el).find('th');
          $td.each(function(index, el) {
            $(el).outerWidth($th.eq(index).outerWidth());
          });
        });
      }
    }

    // 初期化
    $(this._resizeColumnTable).each(function(index, el) {
      $(el).resizableColumns();
    });

    // DataTable 横スクロール有効と併用時
    $(this._resizeColumnTable).each(function(index, el) {
      var $self = $(el);
      if ($self.closest(scrollAreaSelector).length > 0 && $self.closest(headSelector).length > 0) {
        var $th = $self.find(resizeColumnSellector);

        $th.each(function(index, el) {
          var $self = $(el);
          $self.on('domStyleChange', catchEvent);
          var dsw = domStyleWatcher.Start($self, 'width');
        });
      }
    });
  }

  // check 状態を取得して返却
  _getCheckStatus (self) {
    return $(self).prop('checked');
  }
  // 配信スケジュール
  /*_deliverySchedule (tgt){
    if($(tgt).length){
      var row_len = $(tgt).find('.c-lst_itm').length; //tdの行数
      var $chk_addr = $(tgt).find('.c-lst_itm');

      // 全check
      $('.js-chkAll').on('click', function(){
        remove(); // is-selectクラスの削除
        $chk_addr.find('input').prop("checked", true);
      });

      // 全checkを外す
      $('.js-chkNone').on('click', function(){
        remove(); // is-selectクラスの削除
        $chk_addr.find('input').prop("checked", false);
      });

      // 受講票のOKのみチェック
      $('.js-srchOK').on('click', function(){
        remove(); // is-selectクラスの削除
        for(var i = 0; i < row_len; i++){
          var hasOK = ($chk_addr.eq(i).find('td:eq(2)').text() === 'OK')? true: false;
          $chk_addr.eq(i).find('input').prop("checked", hasOK);
        }
      });

      // td要素選択時
      $('.c-lst_td').on('click', function(){
        var cls = this;
        if($(cls).parents().hasClass('js-dlvry')){
        var slct_idx = $(cls).index();

        switch(slct_idx){
          // 以下のカラムは除外
          case 0: // 送信
          case 1: // メール原稿
          case 4: // 番号
          case 5: // 氏名
          case 7: // メールアドレス
            break;

          // カラム選択
          default:
            var $th_addr = $(cls).parents('.c-lst').find('th'); // thのオブジェクト
            var tgt_str = $(cls).text().trim(); // 選択したtdの文字列
            var cnt = 0; // is-selectのカウンター

            // tdアクセス
            for(var j = 0; j < row_len; j++){
              // tdのオブジェクト
              var $td_addr = $(cls).parents('tbody').find('tr').eq(j).find('td').eq(slct_idx);
              // 他の行に同じ文字列があれば is-selectクラスを追加
              if($td_addr.text().trim() === tgt_str) {
                $td_addr.toggleClass('is-select');
              }
              // １つでもis-selectがあるか確認する
              if($td_addr.hasClass('is-select')){
                ++cnt;
              }
            }

            // １つでもis-selectがあれば thにis-selectクラスを追加
            if(cnt > 0) {
              $th_addr.eq(slct_idx).addClass('is-select');
            }
            else {
              $th_addr.eq(slct_idx).removeClass('is-select');
            }

            // チェックボックスの操作
            // th の is-selectの数
            var $c_lst = $(cls).parents('.c-lst');
            var th_slct = $c_lst.find('.c-lst_head').find('.is-select').length;

            // td の is-selectの数
            for(var k = 0; k < row_len; k++){
              var td_slct = $c_lst.find('.c-lst_itm').eq(k).find('.is-select').length;
              // thにis-selectがなければチェックを外す
              if(th_slct === 0) {
                $c_lst.find('.c-lst_itm').eq(k).find('input').prop("checked", false);
              }
              // AND条件のチェック
              else if(th_slct === td_slct) {
                $c_lst.find('.c-lst_itm').eq(k).find('input').prop("checked", true);
              }
              else {
                $c_lst.find('.c-lst_itm').eq(k).find('input').prop("checked", false);
              }
            }
            break;
          }
        }

      });

      // is-selectクラスの削除
      function remove(){
        $(tgt).find('.is-select').removeClass('is-select');
      }
    }
  }*/

  // .js-clm_check イベント
  _eClmCheck() {
    var cls = this;
    var checkAry = [];
    var checkIdx = 0;
    var delIdx = 0;
    $.each($(cls._clm_check), function(idx, elm) {
      $(elm).on('click', function () {
        // チェックしたチェックボックスのidxを取得
        checkIdx = $(cls._THead).find('th').index($(this).parents('th'));
        // チェックしたら class付与、checkAryにcheckIdxを保持
        if ( cls._getCheckStatus(this) ) {
          $(this).parents('th').addClass('is-clm_check');
          checkAry.push(checkIdx);
        // チェック外したら class削除、checkAryからcheckIdxを削除
        } else {
          $(this).parents('th').removeClass('is-clm_check');
          delIdx = checkAry.indexOf(checkIdx);
          checkAry.splice(delIdx, 1);
        }
        // clmの背景色を変更
        var tableTr = $(cls._TBody).find('tr');
        $.each($(tableTr), function (idx, elm) {
          // 背景色を白に初期化
          $.each( $(elm).find('td'), function(idx2, elm2) {
            $(elm2).removeClass('is-clm_check_child');
          });
          // チェックされているなら td　も背景色を変更
          $.each( $(elm).find('td'), function(idx2, elm2) {
            $.each( checkAry, function(check_idx, check_elm) {
              if ( idx2 === check_elm ) {
                $(elm2).addClass('is-clm_check_child');
              }
            });
          });
        });

      });
    });
  }

  // .js-row_check イベント
  _eRowCheck() {
    var cls = this;
    var checkAry = [];
    var checkIdx = 0;
    var checkClmIdx = 0;
    var delIdx = 0;
    $('body').on('click', cls._row_check, function () {
      // チェックしたチェックボックスのidxを取得
      checkIdx = $(this).parents('table').find('tr').index($(this).parents('tr'));
      // 一列目(リストの先頭)のチェックボックスのみ 選択時に背景色をつける
      checkClmIdx = $(this).parents('td').index();
      if(checkClmIdx !== 0) return;
      // チェックしたら class付与、checkAryにcheckIdxを保持
      if ( cls._getCheckStatus(this) ) {
        $(this).parents('tr').addClass('is-row_check');
        checkAry.push(checkIdx);
      // チェック外したら class削除、checkAryからcheckIdxを削除
      } else {
        $(this).parents('tr').removeClass('is-row_check');
        delIdx = checkAry.indexOf(checkIdx);
        checkAry.splice(delIdx, 1);
      }
    });
    $(document).on('click', cls._row_check_dl, function() {
      var $me = $(this);
      var $prt = $me.parents('tr');
      var isChecked = $me.prop('checked');
      $prt.toggleClass('is-del', isChecked);
      $prt.find('input, select').not(this).attr('disabled', isChecked);
    });
  }

  // th 先頭にチェックつけたら全てチェックする処理
  _eCheckAll() {
    var cls = this;
    $('body').on('click', cls._checkAll, function () {
      // チェックしたら全てのrowをチェックし、class付与する
      if (cls._getCheckStatus(this)) {
        $.each($(cls._TBody + ' tr'), function (idx, elm) {
          $(elm).addClass('is-row_check');
          $(elm).find('input[type="checkbox"]').prop('checked', true).change();
        });
      } else {
        $.each($(cls._TBody + ' tr'), function (idx, elm) {
          $(elm).removeClass('is-row_check');
          $(elm).find('input[type="checkbox"]').prop('checked', false).change();
        });
      }
    });
  }

  // テーブルにリサイズ機能のみを適用させるための初期化処理
  _initNonSortTable() {
    var cls = this;
    $(cls._nonSortTable).DataTable({
      // 件数切替機能 無効
      lengthChange: false,
      // 検索機能 無効
      searching: false,
      // ソート機能 無効
      ordering: false,
      // 情報表示 無効
      info: false,
      // ページング機能 無効
      paging: false,
      // 横スクロールバー 有効
      scrollX: true,
      // default orderを無効
      order: []
    });
  }
}